// angular
import { Component, effect, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
import { PanelCommentSkeletonComponent } from '@app/core/components/panel-comment/panel-comment-skeleton/panel-comment-skeleton.component';
import { PanelCommentComponent } from '@app/core/components/panel-comment/panel-comment.component';
// services
import { CommentsService } from '@app/core/shared/services/comments.service';
// interface
import { ICommentData } from '@app/shared/interfaces/comment.interface';

@Component({
  selector: 'pwj-profile-comments',
  standalone: true,
  imports: [
    TranslateModule,
    PanelCommentComponent,
    NoContentComponent,
    PanelCommentSkeletonComponent,
  ],
  templateUrl: './profile-comments.component.html',
  styleUrl: './profile-comments.component.scss',
})
export class ProfileCommentsComponent {
  public commentsDataLoading!: boolean;
  public commentsData: ICommentData[] = [];

  // dependencies
  private readonly _commentsService = inject(CommentsService);

  constructor() {
    // fetch comments data
    this._commentsService.getUserComments();

    effect(() => {
      // get comments data
      this.commentsDataLoading =
        this._commentsService.userCommentsDataLoading();
    });
    effect(() => {
      // get comments data
      this.commentsData = this._commentsService.commentsData();
    });
  }
}
